import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { map } from "rxjs/operators";
import { AddCommentServiceConstants } from "./add-comment-service.constants";
import { ApiCommentsConstants } from "../../../constants/api-constants/api-comments.constants";
import { ApiLookupConstants } from "../../../constants/api-constants/api-lookup.constants";
let AddCommentService = class AddCommentService {
    http;
    componentName = AddCommentServiceConstants.COMPONENT_NAME;
    constructor(http) {
        this.http = http;
    }
    getLookupsObservable(params) {
        return this.http.get(ApiLookupConstants.URL, { params }).pipe(map(lookups => {
            return lookups;
        }));
    }
    saveComment(params) {
        return this.http.post(`${ApiCommentsConstants.URL}`, params)
            .pipe(map((response) => {
            return response;
        }));
    }
    static ctorParameters = () => [
        { type: HttpClient }
    ];
};
AddCommentService = __decorate([
    Injectable({
        providedIn: "root"
    })
], AddCommentService);
export { AddCommentService };
